const dataTableData = {
  columns: [
    { Header: "#", accessor: "#", width: "5%" },
    { Header: "الوصف", accessor: "description", width: "20%" },
    { Header: "تاريخ البدأ", accessor: "startDate", width: "15%" },
    { Header: "تاريخ الانتهاء", accessor: "endDate", width: "15%" },
    { Header: "الأولوية", accessor: "priority", width: "10%" },
    { Header: "المسؤولية", accessor: "responsibilityText", width: "15%" },
    { Header: "الحالة", accessor: "status", width: "10%" },
    { Header: "وصف الحل", accessor: "solutionDescription", width: "20%" },
    { Header: "اجراء", accessor: "actions", width: "10%" },
  ],

  rows: [],
};

export default dataTableData;
